module.exports = __webpack_public_path__ + "img/legalImage.8e6599a6.png";